import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PieGastosDelMesPorEmpresa from '../PieGastosDelMesPorEmpresa/PieGastosDelMesPorEmpresa';
import TablaMultiempresa from '../TablaMultiempresa/TablaMultiempresa';
import { fechaInicioPeriodoMesActualFunc, fechaFinPeriodoMesActualFunc } from '../../../../shared/fechas';
import { storageMonedaSigno } from '../../../../shared/sessionData';
import { formatNumber } from '../../../../shared/formatNumber';

import * as actions from '../../../../store/actions/index';

const MultiChartGastosDelMesPorEmpresa = (props) => {
    const [viewAsPie, setViewAsPie] = useState(true);

    useEffect(() => {
        if (!props.estaCargado && !props.estaOculto && props.ejecucionDePagina) 
          props.onLoadChart();
        
    }, [props.ejecucionDePagina]);
    
    const handleChangeView = () => {
        setViewAsPie(!viewAsPie)
    }

    return(
        viewAsPie 
        ? 
            <PieGastosDelMesPorEmpresa 
                ejecucionDePagina={props.ejecucionDePagina}
                onPorcionClick={props.onPorcionClick}
                onChangeViewClick={handleChangeView}
                title={`Gastos del mes por empresa ${fechaInicioPeriodoMesActualFunc()} al ${fechaFinPeriodoMesActualFunc()}`}
                subtitle={`Total: ${storageMonedaSigno()} ${formatNumber(props.totalGastos)}`}
                height={300}
                width={'100%'}
            />
        : 
            <TablaMultiempresa 
                empresas={props.gastos}
                onChangeViewClick={handleChangeView}
                title={`Gastos del mes por empresa ${fechaInicioPeriodoMesActualFunc()} al ${fechaFinPeriodoMesActualFunc()}`}
                subtitle={`Total: ${storageMonedaSigno()} ${formatNumber(props.totalGastos)}`}
                height={245}
                width={'100%'}
            />
    )
}

const mapStateToProps = (state) => {
    return {
        gastos: state.multiempresa.gastosDelMesPorEmpresa.gastos,
        totalGastos: state.multiempresa.gastosDelMesPorEmpresa.totalGastos,
        loading: state.multiempresa.gastosDelMesPorEmpresa.loading,
        estaCargado: state.multiempresa.gastosDelMesPorEmpresa.estaCargado,
        estaOculto: state.configuraciones.indicadoresOcultosPorUsuario.indicadores.gastosDelMesMultiempresa
    }
}
  
const mapDispatchToProps = (dispatch) => {
    return {
      onLoadChart: () => dispatch(actions.loadGastosDelMesPorEmpresa())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MultiChartGastosDelMesPorEmpresa);